module.exports = {"patient":{"id":"patient","text":"Patient"},"doctor":{"id":"doctor","text":"Doctor"},"analysis":{"id":"analysis","text":"Analysis User"},"statistician":{"id":"statistician","text":"DB Statistician"},"nushu_x_user":{"id":"nushu_x_user","text":"NushuX User"}}


//////////////////
// WEBPACK FOOTER
// ./src/userTypes.json
// module id = M8GX
// module chunks = 1